export default __webpack_public_path__ + "fbcebe8602add509fb92870f6c9edb4f.gif";